import {AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild} from '@angular/core';
import {Image} from "../../interfaces/image";

@Component({
  selector: 'brt-story-avatar',
  templateUrl: './story-avatar.component.html',
  styleUrls: ['./story-avatar.component.scss']
})
export class StoryAvatarComponent implements AfterViewInit{
  @ViewChild('ellipse') set setEllipse(val: ElementRef) {
    if(val) {
      this.ellipse = val;
      this.setAvatarCircleSize();
      this.setCircleProgressUI();
    }
  };

  ellipse!: ElementRef;
  @Input('image') image!: Image;
  @Input('progress') set setProgress(val: number) {
    if(val > 1) val = val / 100;
    this.progress = val;
    this.setCircleProgressUI();
  };

  @HostListener('window:resize', ['$event'])
  onResize($event: any) {
    this.setAvatarCircleSize();
    this.setCircleProgressUI();
  }

  avatarCircleSize = 0;
  progress = 0.0;

  ngAfterViewInit() {

  }

  setCircleProgressUI() {
    if(this.ellipse) {
      const htmlEl = this.ellipse.nativeElement as HTMLElement;
      htmlEl.querySelector("ellipse")?.style.setProperty("stroke-dasharray", `${Math.ceil(this.avatarCircleSize * this.progress)}, ${Math.ceil(this.avatarCircleSize)}`);
    }
  }

  setAvatarCircleSize() {
    if(this.ellipse) {
      const htmlEl = this.ellipse.nativeElement as HTMLElement;
      this.avatarCircleSize = htmlEl.clientWidth * 3.14;
    }

  }

}
